import { z } from 'zod';
import { INTEGRATION_TYPES } from '../integrations.constants';

export const TorqConnectBodySchema = z.object({
  webhookUrl: z.url(),
});

export type TorqConnectBody = z.infer<typeof TorqConnectBodySchema>;

export const TorqProviderMetaSchema = z.object({
  webhookUrlMasked: z.string().min(1),
});

export type TorqProviderMeta = z.infer<typeof TorqProviderMetaSchema>;

export const TorqConnectionStatusResponseSchema = z.object({
  provider: z.literal(INTEGRATION_TYPES.TORQ),
  status: z.enum(['VALID', 'EXPIRED', 'REVOKED', 'NOT_CONNECTED']),
  webhookUrlMasked: z.string().nullable(),
  pushFindingsEnabled: z.boolean(),
});

export type TorqConnectionStatusResponse = z.infer<
  typeof TorqConnectionStatusResponseSchema
>;

export const TorqErrorBodySchema = z.object({
  message: z.string().optional(),
});
